export default "__VITE_ASSET__BKmhFEBX__"